'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ScheduleEngineAppIcon = function ScheduleEngineAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 68.67 68.67"
  }), React__default["default"].createElement("circle", {
    cx: "34.33",
    cy: "34.33",
    r: "34.33",
    style: {
      fill: "#3f738d"
    }
  }), React__default["default"].createElement("path", {
    style: {
      fill: "#abdcd5"
    },
    d: "M54 20l-17.07-9.9a5.18 5.18 0 00-5.19 0L14.67 20a5.19 5.19 0 00-2.15 2.38v.07a3.12 3.12 0 00-.15.39c0 .05 0 .1-.05.15l-.09.32v.21a2.56 2.56 0 00-.05.27v1.49a2.5 2.5 0 00.05.29 1.42 1.42 0 000 .2l.09.33s0 .09.05.13a2.9 2.9 0 00.16.41v.05A5.16 5.16 0 0014.67 29l34.09 19.7A5.23 5.23 0 0054 39.64L27.75 24.49l6.58-3.81 11.82 6.83v4.72l10.46 6V24.49A5.23 5.23 0 0054 20zM34.28 47.94l-11.76-6.79v-4.72l-10.47-6v13.64a5.41 5.41 0 002.7 4.68l17 9.83a5.11 5.11 0 005.18 0l11.71-7-10.37-6z"
  }));
};

var ScheduleEngineAppIcon$1 = iconStyles()(ScheduleEngineAppIcon);

module.exports = ScheduleEngineAppIcon$1;
